export default __webpack_public_path__ + "fleks_background.jpg";